import { render, staticRenderFns } from "./OrderConfiguration.vue?vue&type=template&id=24549c41"
import script from "./OrderConfiguration.vue?vue&type=script&lang=js"
export * from "./OrderConfiguration.vue?vue&type=script&lang=js"
import style0 from "./OrderConfiguration.vue?vue&type=style&index=0&id=24549c41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports